<div class="h-full flex flex-col w-full gap-2 p-2 min-w-0 overflow-hidden">
    <!-- Top bar: bundle selector, search, sort, filter -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-2 w-full">
        <div class="flex flex-wrap md:flex-nowrap items-center gap-2 flex-1 min-w-0">
            <div class="w-[20%]">
                <app-select [(value)]="selectedBundleId" [options]="clauseBundleOptions" [config]="bundleSelectConfig"
                    (onChange)="onBundleChange($event.value)">
                </app-select>
            </div>
            <div class="flex-1 md:max-w-md min-w-0">
                <app-search-bar placeholder="Search by clause name or clause text" [(ngModel)]="searchValue"
                    (searchChange)="onSearch()" width="100%">
                </app-search-bar>
            </div>
        </div>
        <div class="flex items-center gap-2">
            <app-popover #sortFilterPopover width="12rem">
                <ng-template #trigger>
                    <app-button icon="pi pi-sort-alt" variant="outlined" severity="contrast" />
                </ng-template>
                <ng-template #body>
                    <div class="flex flex-col text-sm text-gray-800">
                        <app-button label="Name" variant="ghost" severity="contrast"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (clauseSortBy === ClauseSortBy.Name ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="clauseSortBy === ClauseSortBy.Name ? 'pi pi-check' : ''"
                            iconPosition="right"
                            (clicked)="setClauseSort(ClauseSortBy.Name)" />
                        <app-button label="Created date" variant="ghost" severity="contrast"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (clauseSortBy === ClauseSortBy.CreatedAt ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="clauseSortBy === ClauseSortBy.CreatedAt ? 'pi pi-check' : ''"
                            iconPosition="right"
                            (clicked)="setClauseSort(ClauseSortBy.CreatedAt)" />
                        <app-button label="Usage count" variant="ghost" severity="contrast"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (clauseSortBy === ClauseSortBy.UsageCount ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="clauseSortBy === ClauseSortBy.UsageCount ? 'pi pi-check' : ''"
                            iconPosition="right"
                            (clicked)="setClauseSort(ClauseSortBy.UsageCount)" />
                    </div>
                    <hr class="my-2" />
                    <div class="flex flex-col text-sm text-gray-800">
                        <app-button label="Ascending" variant="ghost" severity="contrast"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (clauseSortOrder === 1 ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="clauseSortOrder === 1 ? 'pi pi-arrow-down' : ''"
                            iconPosition="right"
                            (clicked)="setSortOrder(1)" />
                        <app-button label="Descending" variant="ghost" severity="contrast"
                            [class]="'flex justify-between items-center w-full px-4 py-2 rounded-base ' + (clauseSortOrder === -1 ? 'bg-arena-orange-100 text-black' : 'hover:bg-gray-100')"
                            [icon]="clauseSortOrder === -1 ? 'pi pi-arrow-up' : ''"
                            iconPosition="right"
                            (clicked)="setSortOrder(-1)" />
                    </div>
                </ng-template>
            </app-popover>
            <app-button [label]="'Filter' | textCase" variant="outlined" severity="contrast" icon="pi pi-filter"
                (clicked)="openFilterDialog()" />
        </div>
    </div>

    <!-- Selection action bar -->
    <div class="action-bar mb-2" *ngIf="selectedClauseIds.length > 0">
        <div class="action-bar-content">
            <p class="text-sm font-medium">
                {{ selectedClauseIds.length }} item(s) selected
            </p>
            <div class="action-bar-divider"></div>
            <app-button label="Edit" variant="outlined" icon="pi pi-pencil" (clicked)="openBulkEdit()"
                severity="contrast" />
            <div class="action-bar-actions-right">
                <app-button label="Reject" variant="outlined" severity="danger" icon="pi pi-times"
                    (clicked)="bulkRejectClauses()" />
                <app-button label="Approve" variant="outlined" severity="success" icon="pi pi-check"
                    (clicked)="bulkApproveClauses()" />
            </div>
        </div>
    </div>

    <!-- Data table -->
    <div class="flex-1 min-h-0 w-full overflow-hidden"
        [style.height]="selectedClauseIds.length > 0 ? 'calc(100vh - 16rem)' : 'calc(100vh - 12rem)'">
        <app-data-table #dataTable [data]="clausesData" [columns]="clauseTableColumns" [config]="clauseTableConfig"
            [dataKey]="'_id'" tableClass="flex-1" [customTemplates]="templatesMap" [externalPagination]="true"
            [externalFirst]="skip" [externalTotalRecords]="totalRecords" (selectionChange)="onSelectionChange($event)"
            (pageChange)="onPageChange($event)" tableClass="h-full">
        </app-data-table>
    </div>
</div>

<!-- Cell templates -->
<ng-template #clauseBundleTemplateRef let-clause="$implicit">
    <span class="text-sm">{{ getClauseBundleName(clause) }}</span>
</ng-template>

<ng-template #sourceTemplateRef let-clause="$implicit">
    <span class="text-sm">{{ getSourceLabel(clause.source) }}</span>
</ng-template>

<ng-template #createdByTemplateRef let-clause="$implicit">
    <div class="flex items-center gap-2">
        <img [src]="clause.createdBy | userAvatar" alt="" class="w-6 h-6 rounded-full" />
        <span class="text-sm">{{ getCreatedByName(clause) }}</span>
    </div>
</ng-template>

<ng-template #confidenceTemplateRef let-clause="$implicit">
    <span class="text-sm">{{ getConfidenceLabel(clause.confidence) }}</span>
</ng-template>

<ng-template #approveOrRejectTemplateRef let-clause="$implicit">
    <div class="flex items-center gap-2">
        <app-button variant="outlined" size="sm" class="text" severity="success" icon="pi pi-check"
            (clicked)="approveClause(clause)" [attr.aria-label]="'Approve'" />
        <app-button variant="outlined" size="sm" severity="danger" icon="pi pi-times" (clicked)="rejectClause(clause)"
            [attr.aria-label]="'Reject'" />
    </div>
</ng-template>

<ng-template #createdAtTemplateRef let-clause="$implicit">
    <div class="flex items-center gap-1">
        <i class="pi pi-calendar text-gray-400 text-xs"></i>
        <span class="text-sm">{{ formatDate(clause.createdAt) }}</span>
    </div>
</ng-template>

<ng-template #actionsTemplateRef let-clause="$implicit">
    <div (click)="$event.stopPropagation()">
        <app-menu #menu [items]="getClauseMenuOptions(clause)">
            <i class="pi pi-ellipsis-v icon-sm p-0 m-0 cursor-pointer p-2 hover:bg-gray-100 rounded-full transition-colors"
                (click)="menu.toggle($event)"></i>
        </app-menu>
    </div>
</ng-template>

<!-- Bulk Edit Clause Dialog (same as clause-library) -->
<app-dialog [(visible)]="showBulkEditDialog" (closed)="onBulkEditDialogHide()"
    class="w-[70vw] h-[70vh] flex bulk-edit-dialog-content">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2 pl-4">
            <span class="dialog-title">Edit clauses</span>
            <span class="text-sm text-gray-600">
                ({{ savedClauses.size }}/{{ totalEditingCount }})
            </span>
        </div>
    </ng-template>

    <ng-template #bodyTemplate>
        <div class="h-full flex flex-row justify-between gap-4">
            <div class="h-full w-[40%]">
                <div class="clause-cards-container mb-4">
                    <div *ngFor="let clause of editingClauses; let i = index"
                        class="clause-card mb-3 p-3 border rounded-base cursor-pointer transition-all bg-white border-gray-200 shadow-sm"
                        [ngClass]="{'selected-card': currentEditIndex === i}" (click)="selectClauseForEdit(i)">
                        <div class="overflow-auto">
                            <div class="font-semibold text-sm mb-2 truncate">{{ clause.name }}</div>
                            <div class="text-xs text-gray-600 truncate">{{ clause.text }}</div>
                        </div>
                        <div>
                            @if(savedClauses.has(i)) {
                            <div class="flex flex-col gap-1 items-center">
                                <i class="pi pi-check-circle text-success"></i>
                                <span class="text-xs text-success">Done</span>
                            </div>
                            } @else if(currentEditIndex === i) {
                            <i class="pi pi-chevron-right font-bold"></i>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="h-full w-[60%]">
                <div *ngIf="editingClauses[currentEditIndex]"
                    class="flex flex-col border-2 border-gray-100 rounded-base p-4 h-full">
                    <div class="field">
                        <label class="flex text-sm font-medium mb-2">Clause name</label>
                        <textarea [(ngModel)]="editingClauses[currentEditIndex].name"
                            (ngModelChange)="saveClauseInBulkEdit(currentEditIndex)"
                            class="w-full border border-gray-200 px-2 py-3 rounded-xl text-sm outline-none resize-none"
                            rows="1" placeholder="Enter clause name..."></textarea>
                    </div>
                    <div class="field flex flex-col flex-1 min-h-0">
                        <div class="flex items-center justify-between mb-2">
                            <div class="flex items-baseline gap-1">
                                <p class="text-sm">Clause text</p>
                                @if (bulkEditClauseTextExpanded) {
                                <app-button [icon]="'minimize-2'" variant="ghost" severity="contrast"
                                    [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                                    (clicked)="toggleBulkEditClauseTextExpanded()" />
                                } @else {
                                <app-button [icon]="'maximize-2'" variant="ghost" severity="contrast"
                                    [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                                    (clicked)="toggleBulkEditClauseTextExpanded()" />
                                }
                            </div>
                            <div class="flex items-center gap-2">
                                <app-button [icon]="CLAUSE_LIBRARY_ICONS.GENERATE_CLAUSE_TEXT" [iconSource]="ICON_SOURCE.SVG"
                                    [size]="'default'" variant="outlined" severity="contrast"
                                    [pTooltip]="'Generate clause text'" tooltipPosition="top"
                                    (clicked)="generateClauseTextForBulkEdit()" [loading]="bulkEditGenerateLoading" />
                                <app-button [icon]="CLAUSE_LIBRARY_ICONS.REPHRASE_CLAUSE_TEXT" [iconSource]="ICON_SOURCE.SVG"
                                    [size]="'default'" variant="outlined" severity="contrast"
                                    [pTooltip]="'Rephrase clause text'" tooltipPosition="top"
                                    (clicked)="rephraseClauseForBulkEdit()"
                                    [disabled]="!editingClauses[currentEditIndex].text.trim()"
                                    [loading]="bulkEditRephraseLoading" />
                            </div>
                        </div>
                        <div class="relative rounded-lg overflow-hidden"
                            [ngClass]="bulkEditClauseTextExpanded ? 'flex-1 min-h-0' : 'flex-shrink-0'"
                            [style.height]="bulkEditClauseTextExpanded ? null : '7rem'">
                            @if (bulkEditGenerateLoading || bulkEditRephraseLoading) {
                            <div class="absolute inset-0 flex items-start justify-start gap-2 p-3 bg-white/80 z-10 rounded-lg">
                                <app-blob-loader [width]="'1.5rem'" [height]="'1.5rem'"></app-blob-loader>
                                <div class="text-sm italic theme-text">Constructing<span>{{ dots$ | async }}</span></div>
                            </div>
                            }
                            <textarea [(ngModel)]="editingClauses[currentEditIndex].text"
                                (ngModelChange)="saveClauseInBulkEdit(currentEditIndex)"
                                placeholder="Enter clause text..."
                                class="w-full h-full p-3 text-sm outline-none resize-none overflow-y-auto placeholder:text-gray-400 focus:border-orange-500 border-0 box-border"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="flex items-center gap-2">
                <app-button label="Prev" variant="outlined" icon="pi pi-chevron-left"
                    (clicked)="navigateBulkEditPrevious()" [disabled]="isBulkEditPreviousDisabled" />
                <app-button label="Next" variant="outlined" icon="pi pi-chevron-right"
                    (clicked)="navigateBulkEditNext()" [disabled]="isBulkEditNextDisabled" />
            </div>
            <div class="flex gap-2">
                <app-button label="Cancel" variant="outlined" severity="contrast" icon="pi pi-times"
                    (clicked)="onCancelBulkEdit()" />
                <app-button label="Save ({{ savedClauses.size }}/{{ totalEditingCount }})" variant="filled"
                    icon="pi pi-save" (clicked)="onSaveBulkEdit()" [disabled]="isBulkEditSaveDisabled"
                    [loading]="isBulkEditSaving" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Prompt for clause text (bulk edit) -->
<app-dialog [(visible)]="showPromptForBulkEditDialog" (closed)="closePromptForBulkEditClauseDialog()"
    class="max-w-[28rem]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col w-full bg-white rounded-lg">
            <div class="flex items-center justify-between px-4 pt-4 pb-2">
                <span class="text-base font-bold text-gray-800">Prompt for clause text</span>
                <app-button icon="pi pi-times" variant="ghost" severity="contrast"
                    (clicked)="closePromptForBulkEditClauseDialog()" />
            </div>
            <div class="px-4 pb-4">
                <textarea [(ngModel)]="promptForBulkEditText" placeholder="Type here"
                    class="w-full min-h-[8rem] p-3 border border-gray-300 rounded-lg text-sm outline-none resize-none placeholder:text-gray-400 focus:border-orange-500"></textarea>
                <div class="flex justify-end mt-3">
                    <app-button label="Submit" variant="filled" severity="primary"
                        (clicked)="submitPromptForBulkEditClause()" [loading]="bulkEditGenerateLoading" />
                </div>
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- View clause dialog -->
<app-dialog [(visible)]="showViewDialog" class="w-[50rem]">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Clause details' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
    <div class="flex flex-col gap-4 p-4" *ngIf="viewClause">
        <div>
            <p class="text-sm font-semibold text-gray-600 mb-1">Clause bundle</p>
            <p class="text-base">{{ getClauseBundleName(viewClause) }}</p>
        </div>
        <div>
            <p class="text-sm font-semibold text-gray-600 mb-1">Clause name</p>
            <p class="text-base">{{ viewClause.name }}</p>
        </div>
        <div>
            <p class="text-sm font-semibold text-gray-600 mb-1">Clause text</p>
            <div class="p-3 border border-gray-300 rounded-lg text-sm overflow-y-auto whitespace-pre-wrap max-h-48">{{
                viewClause.text || '—' }}</div>
        </div>
        <div class="grid grid-cols-2 gap-4">
            <div>
                <p class="text-sm font-semibold text-gray-600 mb-1">Source</p>
                <p class="text-base">{{ getSourceLabel(viewClause.source) }}</p>
            </div>
            <div>
                <p class="text-sm font-semibold text-gray-600 mb-1">Created by</p>
                <p class="text-base">{{ getCreatedByName(viewClause) }}</p>
            </div>
            <div>
                <p class="text-sm font-semibold text-gray-600 mb-1">Confidence</p>
                <p class="text-base">{{ getConfidenceLabel(viewClause.confidence) }}</p>
            </div>
            <div>
                <p class="text-sm font-semibold text-gray-600 mb-1">Created date</p>
                <p class="text-base">{{ formatDate(viewClause.createdAt) }}</p>
            </div>
        </div>
    </div>
    </ng-template>
    <ng-template #footerTemplate>
        <app-button label="Close" variant="outlined" severity="contrast" icon="pi pi-times"
            (clicked)="showViewDialog = false" />
    </ng-template>
</app-dialog>

<!-- View/Edit clause dialog (same UI as clause-library). Disable close when loading to prevent accidental close during generation. -->
@if (currentClause && (currentClause._id ?? currentClause.name)) {
<app-dialog [visible]="showAddEditDialog" (closed)="onAddEditDialogVisibleChange(false)"
    [closable]="!(generateClauseTextLoading || rephraseClauseLoading)"
    [showCloseButton]="!(generateClauseTextLoading || rephraseClauseLoading)"
    class="w-[40rem]">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ (isEditMode ? 'Edit clause' : 'Clause details') | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2" [class.opacity-50]="!isEditMode">
            <div>
                <p class="text-sm font-semibold mb-2">Clause bundle</p>
                <app-multi-select [options]="editClauseBundleOptions" [(value)]="currentClauseBundleIds"
                    [config]="{placeholder: 'Select clause bundles', styleClass: 'w-full', appendTo: 'body', disabled: !isEditMode}">
                </app-multi-select>
            </div>
            @if(!isEditMode) {
            <div class="flex flex-col gap-2">
                <div class="flex flex-col gap-1">
                    <p class="text-sm font-semibold text-gray-600">Source</p>
                    <div class="p-2 border border-gray-300 rounded-lg">
                        <span class="text-sm">{{ getSourceLabel(currentClause.source!) }}</span>
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div class="flex flex-col gap-1">
                        <p class="text-sm font-semibold text-gray-600">Created by</p>
                        <div class="p-2 border border-gray-300 rounded-lg">
                            <span class="text-sm">{{ getCreatedByName($any(currentClause)) }}</span>
                        </div>
                    </div>
                    <div class="flex flex-col gap-1">
                        <p class="text-sm font-semibold text-gray-600">Created date</p>
                        <div class="p-2 border border-gray-300 rounded-lg">
                            <span class="text-sm">{{ formatDate(currentClause.createdAt) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        <div class="flex flex-col gap-2">
            <p class="text-sm font-semibold">Clause name @if(isEditMode) {<span class="text-red-500"> *</span>}</p>
            @if(!isEditMode) {
            <p class="text-base">{{ currentClause.name }}</p>
            } @else {
            <input type="text" placeholder="Type here"
                class="w-full p-3 border border-gray-300 rounded-lg text-sm outline-none placeholder:text-gray-400 focus:border-orange-500"
                [(ngModel)]="currentClause.name" />
            }
        </div>
        <div class="flex flex-col" [class.gap-2]="isEditMode">
            <div class="flex items-center justify-between">
                <div class="flex items-baseline gap-1">
                    <p class="text-sm font-semibold mb-2">Clause text</p>
                    <app-button [icon]="'maximize-2'" variant="ghost" severity="contrast"
                        [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                        (clicked)="toggleClauseTextExpanded()" />
                </div>
                @if(isEditMode) {
                <div class="flex items-center gap-2">
                    <app-button [icon]="CLAUSE_LIBRARY_ICONS.GENERATE_CLAUSE_TEXT" [iconSource]="ICON_SOURCE.SVG"
                        [size]="'default'" variant="filled" severity="contrast" class="p-1.5 rounded"
                        (clicked)="generateClauseTextForEdit()" [loading]="generateClauseTextLoading" />
                    <app-button [icon]="CLAUSE_LIBRARY_ICONS.REPHRASE_CLAUSE_TEXT" [iconSource]="ICON_SOURCE.SVG"
                        [size]="'default'" variant="filled" severity="contrast" class="p-1.5 rounded"
                        (clicked)="rephraseClauseForEdit()" [disabled]="!(currentClause.text ?? '').trim()"
                        [loading]="rephraseClauseLoading" />
                </div>
                }
            </div>
            <div class="relative border border-gray-300 rounded-lg overflow-hidden bg-white"
                [style.height]="isClauseTextExpanded ? '18rem' : '7rem'">
                @if(isEditMode && (generateClauseTextLoading || rephraseClauseLoading)) {
                <div class="absolute inset-0 flex items-start justify-start gap-2 p-3 bg-white/80 z-10 rounded-lg">
                    <app-blob-loader [width]="'1.5rem'" [height]="'1.5rem'"></app-blob-loader>
                    <div class="text-sm italic theme-text">
                        Constructing<span>{{ dots$ | async }}</span>
                    </div>
                </div>
                }
                @if(!isEditMode) {
                <div class="w-full h-full p-3 text-sm overflow-y-auto whitespace-pre-wrap">{{ currentClause.text }}
                </div>
                } @else {
                <textarea placeholder="Type here"
                    class="w-full h-full p-3 pr-24 text-sm outline-none resize-none overflow-y-auto placeholder:text-gray-400 focus:border-orange-500 border-0 box-border"
                    [(ngModel)]="currentClause.text"></textarea>
                }
            </div>
        </div>
    </div>
    </ng-template>
    <ng-template #footerTemplate>
        @if(isEditMode) {
        <div class="flex justify-end gap-2">
            <app-button label="Save" variant="filled" (clicked)="saveClause()" [enableThrottle]="true"
                severity="primary"
                [disabled]="!currentClause.name || saveClauseLoading || generateClauseTextLoading || rephraseClauseLoading"
                [loading]="saveClauseLoading" />
        </div>
        }
    </ng-template>
</app-dialog>
}

<!-- Bulk link to bundle dialog -->
<app-dialog [(visible)]="showBulkLinkBundleDialog" class="w-[50rem]">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Link to a clause bundle' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
    <div class="flex flex-col gap-4 px-4">
        <p class="text-sm text-black">You are linking {{ selectedClauseIds.length }} selected clauses. Choose clause
            bundles below.</p>
        <div class="flex items-center gap-3">
            <div class="flex-1 relative">
                <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-500 text-sm"></i>
                <input type="text" [(ngModel)]="bulkLinkSearchValue" placeholder="Search with name"
                    class="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-sm outline-none placeholder:text-gray-400 focus:border-orange-500" />
            </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-96 overflow-y-auto pr-2">
            @for (bundle of filteredClauseBundles; track bundle._id) {
            <div class="flex items-start gap-3 p-4 border rounded-lg cursor-pointer transition-all hover:bg-gray-50"
                [class.border-orange-500]="isBundleSelected(bundle._id)"
                [class.bg-orange-50]="isBundleSelected(bundle._id)"
                [class.border-gray-200]="!isBundleSelected(bundle._id)" (click)="toggleBundleSelection(bundle._id)">
                <div class="flex items-center justify-center w-5 h-5 mt-0.5 flex-shrink-0">
                    <i
                        [class]="isBundleSelected(bundle._id) ? 'pi pi-check-square text-orange-500 text-xl' : 'pi pi-square-off text-gray-400 text-xl'">
                    </i>
                </div>
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-semibold text-gray-900 mb-1 truncate">{{ bundle.name }}</p>
                </div>
            </div>
            }
            @if (filteredClauseBundles.length === 0) {
            <div class="col-span-2 flex min-h-[12rem] items-center justify-center py-8 text-sm text-gray-500">No clause
                bundles found</div>
            }
        </div>
    </div>
    </ng-template>
    <ng-template #footerTemplate>
        <span class="flex gap-2">
            <app-button label="Cancel" variant="outlined" severity="contrast"
                (clicked)="showBulkLinkBundleDialog = false" />
            <app-button label="Submit" variant="filled" (clicked)="submitBulkLinkToBundles()" [enableThrottle]="true"
                severity="primary" [disabled]="selectedBundleIdsForBulkLink.length === 0 || bulkLinkingToBundles"
                [loading]="bulkLinkingToBundles" />
        </span>
    </ng-template>
</app-dialog>

<!-- Filter drawer -->
@if (filterDialog) {
<p-drawer [(visible)]="filterDialog" position="right">
    <ng-template pTemplate="headless">
        <div class="flex items-center justify-between p-4 flex-shrink-0 border-b">
            <span class="text-lg font-semibold">Filter</span>
            <div class="flex gap-2 items-center">
                <i class="pi pi-times cursor-pointer" (click)="filterDialog=false"></i>
            </div>
        </div>
        <div class="flex flex-col h-full justify-between">
            <div class="p-4 gap-y-4 flex flex-col overflow-y-auto">
                <div>
                    <div class="text-sm font-semibold mb-2">Source</div>
                    <app-multi-select [options]="sourceOptions" [(value)]="selectedSources" optionLabel="name"
                        optionValue="value" [config]="{placeholder: 'Select source', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>
                <div>
                    <div class="text-sm font-semibold mb-2">Created by</div>
                    <app-multi-select [options]="userOptions" [(value)]="selectedCreators" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select creators', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>
                <div>
                    <div class="text-sm font-semibold mb-2">Clause bundle</div>
                    <app-multi-select [options]="clauseBundleOptions" [(value)]="selectedClauseBundles"
                        [config]="{placeholder: 'Select clause bundles', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>
                <div>
                    <div class="text-sm font-semibold mb-2">Created date</div>
                    <app-datepicker [(value)]="selectedDateRange" (onChange)="onDateRangeChange()" [config]="{
                        selectionMode: 'range',
                        placeholder: 'Select date range',
                        styleClass: 'w-full',
                        showButtonBar: false,
                        showIcon: true,
                        appendTo: 'body',
                    }">
                    </app-datepicker>
                    <div class="flex items-center gap-2 mt-2">
                        <app-button label="Today" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('today') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('today')" />
                        <app-button label="Last 7 days" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('last7days') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('last7days')" />
                        <app-button label="Last 30 days" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('last30days') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('last30days')" />
                    </div>
                </div>
                <div>
                    <div class="text-sm font-semibold mb-2">Usage count</div>
                    <div class="flex items-center gap-2">
                        <input type="number" [(ngModel)]="minUsageCount" [min]="0" placeholder="Min"
                            class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm text-gray-700 outline-none focus:border-orange-500" />
                        <input type="number" [(ngModel)]="maxUsageCount" [min]="minUsageCount || 0" placeholder="Max"
                            class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm text-gray-700 outline-none focus:border-orange-500" />
                    </div>
                </div>
            </div>
            <div class="p-4 flex gap-2 border-t border-gray-200">
                <div class="flex-1 min-w-0">
                    <app-button label="Clear all" variant="outlined" severity="contrast" (clicked)="clearFilter()"
                        [fullWidth]="true" />
                </div>
                <div class="flex-1 min-w-0">
                    <app-button label="Apply filter" variant="filled" severity="primary" (clicked)="applyFilter()"
                        [enableThrottle]="true" [fullWidth]="true" />
                </div>
            </div>
        </div>
    </ng-template>
</p-drawer>
}

<!-- Bulk approve confirm -->
<app-dialog [(visible)]="showBulkApproveConfirmDialog" [closable]="false" [showCloseButton]="false"
    class="max-w-[28rem]">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2">
            <div class="flex items-center justify-center flex-shrink-0">
                <i class="pi pi-info-circle text-xl text-orange-600"></i>
            </div>
            <div class="flex flex-col">
                <p class="text-gray-900 font-semibold text-sm">Are you sure you want to approve all the clauses?</p>
            </div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast" (clicked)="cancelBulkApproveConfirm()" />
            <app-button label="Yes, approve" variant="filled" (clicked)="confirmBulkApprove()" [enableThrottle]="true"
                severity="primary" />
        </div>
    </ng-template>
</app-dialog>

<!-- Bulk reject confirm -->
<app-dialog [(visible)]="showBulkRejectConfirmDialog" [closable]="false" [showCloseButton]="false"
    class="max-w-[28rem]">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2">
            <div class="flex items-center justify-center flex-shrink-0">
                <i class="pi pi-info-circle text-xl text-orange-600"></i>
            </div>
            <div class="flex flex-col">
                <p class="text-gray-900 font-semibold text-sm">Are you sure you want to reject all the clauses?</p>
            </div>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast" (clicked)="cancelBulkRejectConfirm()" />
            <app-button label="Yes, reject" variant="filled" (clicked)="confirmBulkReject()" [enableThrottle]="true"
                severity="danger" />
        </div>
    </ng-template>
</app-dialog>

<!-- Delete confirm -->
@if (showDeleteConfirmDialog) {
<app-delete-confirmation [(visible)]="showDeleteConfirmDialog"
    [headerText]="'You are about to delete ' + itemsToDeleteCount + ' clause' + (itemsToDeleteCount > 1 ? 's' : '')"
    bodyText="This action cannot be undone. Are you sure?" confirmButtonText="Yes, delete" (onConfirm)="confirmDelete()"
    (onCancel)="cancelDelete()">
</app-delete-confirmation>
}

<p-confirmDialog></p-confirmDialog>